import { forwardRef } from "react";
import "./Button.scss";
import { ButtonProps } from "./types";
import classNames from "classnames";
import { Typography, Icon } from "top-brains-ui";

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = "primary",
      backgroundColor,
      border,
      size = "small",
      onClick,
      onCopy,
      label,
      disabled = false,
      children = null,
      type = "button",
      className = "",
      style = {},
      iconName,
      iconPosition = "left",
      isChooseFile = false,
      buttonWidth = "auto",
      buttonHeight = "auto",
      handleCloseIcon,
      selectedFile,
      fontSize = 10,
      typographyStyle,

      iconColor = "",
      ...props
    }: ButtonProps,
    ref
  ) => {
    const renderIcon = () =>
      iconName && (
        <div
          onClick={(e) => {
            if (iconName === "close") {
              e.stopPropagation();
              handleCloseIcon?.();
            }
          }}
        >
          <Icon
            height={isChooseFile ? 14 : 8}
            width={isChooseFile ? 14 : 8}
            color={
              iconName === "close"
                ? "var(--delete-button-attachment)"
                : variant === "danger"
                ? "var(--status-rejected-text-color)"
                : iconColor ||
                  (variant === "primary"
                    ? "var(--primary-icon-color)"
                    : "var(--secondary-icon-color)")
            }
            name={iconName}
            className="button-icon"
            disabled={disabled}
          />
        </div>
      );
    return (
      <button
        type={type}
        ref={ref}
        className={classNames(
          "button-style",
          `button-style--${size}`,
          `button-style--${variant}`,
          `${className}`,
          { "button-choose-file": isChooseFile },
          { "button-choose-file-text": selectedFile }
        )}
        style={{
          backgroundColor,
          border,
          ...style,
          width: buttonWidth,
          height: buttonHeight,
        }}
        onClick={onClick}
        onCopy={onCopy}
        disabled={disabled}
        {...props}
      >
        {iconPosition === "left" && renderIcon()}
        <Typography
          fontSize={fontSize}
          style={{ ...typographyStyle }}
          fontWeight="semi-bold"
          className={classNames(`button-style-${variant}--text`, {
            "button-choose-file-text": selectedFile,
          })}
        >
          {label}
        </Typography>
        {iconPosition === "right" && renderIcon()}
        {children}
      </button>
    );
  }
);
export default Button;
